import { z } from 'zod';

// ---- branded primitives -------------------------------------------------
// We use Zod brands so an OrgId can never be passed where a StoreId is
// expected, even though both are UUID strings at runtime.

export const Uuid = z.string().uuid();
export type Uuid = z.infer<typeof Uuid>;

export const OrgId = Uuid.brand<'OrgId'>();
export type OrgId = z.infer<typeof OrgId>;

export const StoreId = Uuid.brand<'StoreId'>();
export type StoreId = z.infer<typeof StoreId>;

export const UserId = Uuid.brand<'UserId'>();
export type UserId = z.infer<typeof UserId>;

// ---- shared row contract -----------------------------------------------
// Every operational row in every module's schema satisfies this shape.

export const TenantRowSchema = z.object({
  org_id: OrgId,
  store_id: StoreId,
});
export type TenantRow = z.infer<typeof TenantRowSchema>;

// ---- membership role ---------------------------------------------------
export const MembershipRole = z.enum(['owner', 'admin', 'operator', 'viewer']);
export type MembershipRole = z.infer<typeof MembershipRole>;

// ---- active context (mirrors @pc/db ActiveContext) ---------------------
export const ActiveContextSchema = z.object({
  orgId: OrgId,
  storeId: StoreId,
});
export type ActiveContext = z.infer<typeof ActiveContextSchema>;
